import { render, staticRenderFns } from "./BindBankAcc.vue?vue&type=template&id=d0d650dc&scoped=true"
import script from "./BindBankAcc.vue?vue&type=script&lang=js"
export * from "./BindBankAcc.vue?vue&type=script&lang=js"
import style0 from "./BindBankAcc.vue?vue&type=style&index=0&id=d0d650dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0d650dc",
  null
  
)

export default component.exports